<template>
  <div class="mapInfo">
    <div class="mapInfo-title">人员信息</div>
    <el-image class="mapInfo-img"
              :src="inrenYuanData.img">
    </el-image>

    <div>姓名：{{inrenYuanData.accountName}}</div>
    <div>地址：{{inrenYuanData.location}}</div>
    <div>时间：{{inrenYuanData.createTime}}</div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelMapInfo',
  props: ['inrenYuanData'],
  data () {
    return {
	time:'',
	times:null,
    };
  },
	
  mounted () {
	this.timechange()
	this.dangqian()
	clearInterval(this.time)
	this.time=null
	this.times=setInterval(()=>{
			 this.time=new Date(new Date(new Date().toLocaleDateString()).getTime()).Format("yyyy-MM-dd HH:mm:ss")
	},1000)
  },
  methods: {
	  dangqian(){
	  },
	  //时间
	  timechange(){
	  	Date.prototype.Format = function (fmt) {
	  	    var o = {
	  	        "M+": this.getMonth() + 1, //月份 
	  	        "d+": this.getDate(), //日 
	  	        "H+": this.getHours(), //小时 
	  	        "m+": this.getMinutes(), //分 
	  	        "s+": this.getSeconds(), //秒 
	  	        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
	  	        "S": this.getMilliseconds() //毫秒 
	  	    };
	  	    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	  	    for (var k in o)
	  	    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	  	    return fmt;
	  	}
	  },
  },
  beforeDestroy(){
  	  clearInterval(this.time)
  	  this.time=null
  },
};
</script>

<style lang="scss" scoped>
.mapInfo {
  width: 300px;
  // height: 351px;
  // background: rgba(25, 58, 127, 0.8);
  // border-radius: 10px;
  // border: 1px solid #33b4f0;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  .mapInfo-title {
    // width: 100%;
    background: #0d333a;
    border-radius: 9px 9px 0px 0px;
  }
  .mapInfo-img {
    width: calc(100% - 20px);
  }
  div {
    padding: 10px 0 10px 10px;
  }
}
</style>